import {
    KHO_COUNT_ASSIGN_SUCCESS,
    KHO_HISTORY_LIST_SUCCESS,
    KHO_IMPORT_SUCCESS,
    KHO_LIST_SUCCESS,
    KHO_NEW_CARE_SUCCESS,
    KHO_ONE_SUCCESS,
    KHO_UPDATE_FILTER,
  
    KHO_UPDATE_HOMEPAGE_FILTER,
    KHO_HOMEPAGE_LIST_SUCCESS,
    KHO_HOMEPAGE_ONE_SUCCESS,
  
    KHO_LIMIT_UPDATE_HOMEPAGE_FILTER,
    KHO_LIMIT_HOMEPAGE_LIST_SUCCESS,
    KHO_LIMIT_HOMEPAGE_ONE_SUCCESS,
  } from 'src/actions/kho.action';
  import { LOOKUP_CLEANER } from 'src/actions/lookup.action';
  
  import {
    DEFAULT_ROW_PER_PAGE,
  } from 'src/utils/constants';
  
  import dayjs from 'dayjs';
  
  const today = new Date();
  
  const initState = {
    filter: {
      message: '',
      startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
      endDate: dayjs(today),
      page: 0,
      limit: DEFAULT_ROW_PER_PAGE,
    },
    homepageKhoFilter: {
      message: '',
      startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
      endDate: dayjs(today),
      homepageKhoPage: 0,
      homepageKhoLimit: DEFAULT_ROW_PER_PAGE,
    },
    homepageKhoLimitFilter: {
      message: '',
      startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
      endDate: dayjs(today),
      homepageKhoLimitPage: 0,
      homepageKhoLimitLimit: DEFAULT_ROW_PER_PAGE,
    },
    items: [],
    total: 0,
    selected: undefined,
  
    homepageKhoItems: [],
    homepageKhoTotal: 0,
    homepageKhoSelected: undefined,
  
    homepageKhoLimitItems: [],
    homepageKhoLimitTotal: 0,
    homepageKhoLimitSelected: undefined,
  
    temp: [],
    countAssign: 0,
    history: [],
    totalHistory: 0,
    newCare: undefined,
    canCare: 0,

    ton_hien_tai: 0,
    ton_dau_ky: 0,
    nhap_trong_ky: 0,
    xuat_trong_ky: 0,
    ton_cuoi_ky: 0,
  }
  
  const khoReducer = (state = initState, action) => {
    switch (action.type) {
      case KHO_UPDATE_FILTER:  {
        if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
          if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
          if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
        }
        return {
          ...state,
          filter: action.data,
        }
      }
      case KHO_LIST_SUCCESS: {
        return {
          ...state,
          items: action.data.items,
          total: action.data.total,
          ton_hien_tai: action.data.summary.ton_hien_tai,
          ton_dau_ky: action.data.summary.ton_dau_ky,
          nhap_trong_ky: action.data.summary.nhap_trong_ky,
          xuat_trong_ky: action.data.summary.xuat_trong_ky,
          ton_cuoi_ky: action.data.summary.ton_cuoi_ky,
          ton_hien_tai_gia_tri: action.data.summary.ton_hien_tai_gia_tri,
          ton_dau_ky_gia_tri: action.data.summary.ton_dau_ky_gia_tri,
          nhap_trong_ky_gia_tri: action.data.summary.nhap_trong_ky_gia_tri,
          xuat_trong_ky_gia_tri: action.data.summary.xuat_trong_ky_gia_tri,
          ton_cuoi_ky_gia_tri: action.data.summary.ton_cuoi_ky_gia_tri,
        }
      }
      case KHO_ONE_SUCCESS: {
        return {
          ...state,
          selected: action.data
        }
      }
      case KHO_UPDATE_HOMEPAGE_FILTER:  {
        if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageKhoFilter !== 'undefined' && state.homepageKhoFilter) {
          if (action.data.homepageKhoPage == 'no_update' && typeof state.homepageKhoFilter.homepageKhoPage !== 'undefined') action.data.homepageKhoPage = state.homepageKhoFilter.homepageKhoPage;
          if (action.data.homepageKhoLimit == 'no_update' && typeof state.homepageKhoFilter.homepageKhoLimit !== 'undefined') action.data.homepageKhoLimit = state.homepageKhoFilter.homepageKhoLimit;
        }
        return {
          ...state,
          homepageKhoFilter: action.data,
        }
      }
      case KHO_HOMEPAGE_LIST_SUCCESS: {
        return {
          ...state,
          homepageKhoItems: action.data.homepageKhoItems,
          homepageKhoTotal: action.data.homepageKhoTotal,
        }
      }
      case KHO_HOMEPAGE_ONE_SUCCESS: {
        return {
          ...state,
          homepageKhoSelected: action.data
        }
      }
      case KHO_LIMIT_UPDATE_HOMEPAGE_FILTER:  {
        if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageKhoLimitFilter !== 'undefined' && state.homepageKhoLimitFilter) {
          if (action.data.homepageKhoLimitPage == 'no_update' && typeof state.homepageKhoLimitFilter.homepageKhoLimitPage !== 'undefined') action.data.homepageKhoLimitPage = state.homepageKhoLimitFilter.homepageKhoLimitPage;
          if (action.data.homepageKhoLimitLimit == 'no_update' && typeof state.homepageKhoLimitFilter.homepageKhoLimitLimit !== 'undefined') action.data.homepageKhoLimitLimit = state.homepageKhoLimitFilter.homepageKhoLimitLimit;
        }
        return {
          ...state,
          homepageKhoLimitFilter: action.data,
        }
      }
      case KHO_LIMIT_HOMEPAGE_LIST_SUCCESS: {
        return {
          ...state,
          homepageKhoLimitItems: action.data.homepageKhoLimitItems,
          homepageKhoLimitTotal: action.data.homepageKhoLimitTotal,
        }
      }
      case KHO_LIMIT_HOMEPAGE_ONE_SUCCESS: {
        return {
          ...state,
          homepageKhoLimitSelected: action.data
        }
      }
      case KHO_NEW_CARE_SUCCESS: {
        return {
          ...state,
          newCare: action.data.newCare,
          canCare: action.data.canCare,
        }
      }
      case KHO_IMPORT_SUCCESS: {
        return {
          ...state,
          temp: action.data,
        }
      }
      case KHO_COUNT_ASSIGN_SUCCESS: {
        return {
          ...state,
          countAssign: action.data,
        }
      }
      case KHO_HISTORY_LIST_SUCCESS: {
        return {
          ...state,
          history: action.data.items,
          totalHistory: action.data.total,
        }
      }
      case LOOKUP_CLEANER: {
        return initState
      }
      default: {
        return state;
      }
    }
  }
  export default khoReducer